export const appName = 'search_perseus';
